<div class="view-wrapper">
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
        <div class="dx-card responsive-paddings">
            <dx-toolbar [class]="isContentScrolled ? 'header-toolbar-scrolled' : 'header-toolbar'"
                [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                    <div class="header-text">Quick Actions</div>
                </dxi-item>
            </dx-toolbar>
            <div class="cards-container">
                <quick-action-card class="quick-action-card" title="Top-up Merchant Account">
                    <div top-item>
                        <app-topup-merchant-account (OnMerchantBalanceUpdate)="onMerchantBalanceUpdate($event)" [colCount]="1"></app-topup-merchant-account>
                    </div>
                </quick-action-card>
                <quick-action-card class="quick-action-card" title="Top-up Merchant Wallet">
                    <div top-item>
                        <app-topup-merchant-wallet [colCount]="1"></app-topup-merchant-wallet>
                    </div>
                </quick-action-card>
                <quick-action-card class="quick-action-card" title="Load New Cards">
                    <div top-item>
                        <app-load-new-cards (OnCardStockUpdate)="onNotify($event)"></app-load-new-cards>
                    </div>
                </quick-action-card>
                <quick-action-card class="quick-action-card" title="Allocate Cards to Merchant">
                    <div top-item>
                        <app-allocate-cards-to-merchant [colCount]="1"></app-allocate-cards-to-merchant>
                    </div>
                </quick-action-card>
            </div>
        </div>
    </dx-scroll-view>
</div>